import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NotFound.module.css';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.errorCode}>404</div>
        <h1 className={styles.title}>Page Not Found</h1>
        <p className={styles.message}>
          Oops! The page you are looking for doesn't exist, has been removed, or is temporarily unavailable.
        </p>
        <div className={styles.actions}>
          <button className={styles.backBtn} onClick={() => window.history.back()}>
            <ArrowLeft size={18} /> Go Back
          </button>
          <Link to="/" className={styles.homeBtn}>
            <Home size={18} /> Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
